<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h3 class="mb-0">
          {{ unansweredOnly ? 'Вопросы без ответа' : 'Все комментарии' }}
        </h3>
        <b-form-checkbox
          v-model="unansweredOnly"
          switch
          @change="changeFilter"
        >
          Только вопросы без ответа
        </b-form-checkbox>
      </div>

      <p
        v-if="unansweredOnly && !allComments.length"
        class="text-muted"
      >
        Все вопросы участников отвечены.
      </p>

      <transition-group name="fade" tag="div" class="comments-list">
        <CommentItem
          v-for="comment in allComments"
          :key="comment.id"
          :comment="comment"
          @refresh="fetchAllComments"
        />
      </transition-group>

      <PaginationControls
        v-if="totalPages > 1"
        :page="page"
        :limit="limit"
        :total-count="totalCount"
        :limit-options="limitOptions"
        @page-change="handlePageChange"
        @limit-change="changeLimit"
      />
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import CommentItem from './CommentItem.vue'
import PaginationControls from './PaginationControls.vue'

export default {
  name: 'CommentsPage',
  components: { BFormCheckbox, CommentItem, PaginationControls },
  data() {
    return {
      allComments: [],
      // the queue of questions waiting for an administrator's reply
      unansweredOnly: false,
      page: 1,
      limit: 10,
      totalPages: 1,
      totalCount: 0,
      limitOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
      ],
    }
  },
  mounted() {
    this.fetchAllComments()
  },
  methods: {
    async fetchAllComments() {
      try {
        const skip = (this.page - 1) * this.limit
        const { data } = await this.$http.get(
          `comment/all?skipCount=${skip}&maxResultCount=${this.limit}${
            this.unansweredOnly ? '&unanswered=true' : ''
          }`,
        )
        this.allComments = data.rows
        this.totalCount = data.count
        this.totalPages = data.totalPages
      } catch (error) {
        console.error('Ошибка при загрузке комментариев:', error)
      }
    },
    changeFilter() {
      this.page = 1
      this.fetchAllComments()
    },
    handlePageChange(page) {
      this.page = page
      this.fetchAllComments()
    },
    changeLimit(limit) {
      this.limit = limit
      this.page = 1
      this.fetchAllComments()
    },
  },
}
</script>
